/** btoa seul échoue sur les caractères hors Latin1 (ex. accents dans un SVG) : on repasse par un encodage UTF-8 sûr. */
export function toSvgDataUri(svgContent: string): string {
  const base64 = btoa(unescape(encodeURIComponent(svgContent)));
  return `data:image/svg+xml;base64,${base64}`;
}
